<script lang="ts">
    import { reviewsIconCollectionManagerContextToken } from "@apps/reviews/context_tokens";
    import Icon from "@components_v2/Icon.svelte";
    import { getTypedContext } from "@lib/svelte-typed-context";
    import CN from "classnames";

    export let rating: number;
    let className = "";
    export { className as class };
    export let height = "24";
    export let width = "24";

    const iconCollection$ = getTypedContext(
        reviewsIconCollectionManagerContextToken
    ).getIconCollection();

    $: rounded = Math.round(rating * 2) / 2;
</script>

<div
    class={CN("gw-rv-rating gw-default-reset", className)}
    aria-label={`${rating} out of 5 ratings`}
    role="img"
>
    {#each [1, 2, 3, 4, 5] as starNumber}
        {#if rounded >= starNumber}
            <Icon {width} {height} class="gw-rv-rating__star">
                <svelte:component this={$iconCollection$?.filled} />
            </Icon>
        {:else if rounded >= starNumber - 0.5}
            <Icon
                {width}
                {height}
                class="gw-rv-rating__star gw-rv-rating__star-half"
            >
                <svelte:component this={$iconCollection$?.half} />
            </Icon>
        {:else}
            <Icon
                {width}
                {height}
                class="gw-rv-rating__star gw-rv-rating__star-empty"
            >
                <svelte:component this={$iconCollection$?.empty} />
            </Icon>
        {/if}
    {/each}
</div>

<style>
    .gw-rv-rating {
        display: flex;
        align-items: center;
        column-gap: 3px;
    }
    :global(.gw-rv-rating__star) {
        color: var(--gw-rv-icon-starColor);
    }
    :global(.gw-rv-rating__star-empty) {
        color: var(--gw-rv-icon-starColor);
    }
    :global(.gw-rv-rating__star-half) {
        color: var(--gw-rv-icon-starColor);
    }
</style>
